import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Alert, Button, Field, Input } from '../components/ui';
import { errMsg } from '../lib/useApi';

export default function ChangePasswordPage() {
  const { user, changePassword, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const forced = !!user?.must_change_password;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) return setError('รหัสผ่านใหม่อย่างน้อย 8 ตัวอักษร');
    if (next !== confirm) return setError('ยืนยันรหัสผ่านไม่ตรงกัน');
    setBusy(true);
    try {
      await changePassword(current, next);
      nav('/', { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 rounded-2xl border border-line bg-white p-6">
        <div>
          <h1 className="text-xl font-bold">เปลี่ยนรหัสผ่าน</h1>
          <p className="text-sm text-muted">{forced ? 'กรุณาตั้งรหัสผ่านใหม่ก่อนเริ่มใช้งาน' : user?.email}</p>
        </div>
        {error && <Alert>{error}</Alert>}
        <Field label={forced ? 'รหัสผ่านชั่วคราว' : 'รหัสผ่านปัจจุบัน'}>
          <Input type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
        </Field>
        <Field label="รหัสผ่านใหม่" hint="อย่างน้อย 8 ตัวอักษร">
          <Input type="password" autoComplete="new-password" required value={next} onChange={(e) => setNext(e.target.value)} />
        </Field>
        <Field label="ยืนยันรหัสผ่านใหม่">
          <Input type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Field>
        <Button type="submit" variant="primary" size="lg" className="w-full" loading={busy}>
          บันทึกรหัสผ่าน
        </Button>
        {forced ? (
          <Button type="button" variant="ghost" className="w-full" onClick={() => void logout()}>
            ออกจากระบบ
          </Button>
        ) : (
          <Button type="button" variant="ghost" className="w-full" onClick={() => nav(-1)}>
            ยกเลิก
          </Button>
        )}
      </form>
    </div>
  );
}
